export default class formConfig {
  // 招标计划
  static configList() {
    return [
      {
        title: "联合招标其他单位信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "联合招标企业名称：",
            type: "slot",
            slotName: "unionCorpName",
            value: "unionCorpName",
            disabled: true,
            width: "100%"
          },
          {
            label: "",
            type: "slot",
            slotName: "detailList",
            value: "detailList",
            class: "formList"
          },
        ]
      },
      {
        title: "其他信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "备注：",
            value: "tenderUnionDescription",
            type: "textarea",
            width: "100%",
            required: true,
            maxlength: 1200,
            minRows: "3",
            maxRows: "2",
            rule: {
              required: true,
              message: "请填写备注",
              trigger: "blur"
            }
          },
        ]
      },
      {
        title: "联合体招标协议描件",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "联合体招标协议扫描件：",
            type: "slot",
            slotName: "uploadFile",
            width: "1005;",
            tipContent: "保存成功后，请上传相关附件！",
          }
        ]
      },
    ];
  }
}
